
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Home() {
  const features = [
    {
      icon: 'ri-leaf-line',
      title: '日本産精油によるアロマセラピー',
      description: '日本の森林から採られた貴重で高品質な国産精油を使用'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '資格取得可能',
      description: 'アドバイザー資格講座でより専門的な知識を身につけ、講座開催など人に教えられるようになります'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'マンツーマン・オーダーメイド指導',
      description: '１対１のきめ細やかな個人指導\n受講日時は早朝・深夜・隙間時間でも可能なフルオーダー\n※ご希望の方はご友人との受講も可能\n※早朝・深夜の場合はオンライン受講'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '和精油アロマトリートメント',
      description: '国際資格を持つセラピストによる、日本産精油と国産オイルだけを使用した贅沢なアロマトリートメント'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/45c1c17a07a2e0069083f16c479abe89.jfif')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            森の香りで<br />新しい「私の人生」を
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            和精油を用いたアロマセラピーで、<br />
            大切な人のためにいつも頑張っている自分を労わってあげませんか
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">elämäniの特徴</h2>
            <div className="w-20 h-1 bg-green-600 mx-auto"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mb-4 mx-auto">
                  <i className={`${feature.icon} text-green-600 text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm whitespace-pre-line">{feature.description}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-green-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            まずは入門講座から始めませんか？
          </h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            初心者の方でも安心してご参加いただける入門講座をご用意しています。<br />
            和精油の魅力を体感してみてください。
          </p>
          <Link to="/courses">
            <Button size="lg">
              入門講座
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
